/* 全局有三个参数
 * # ___PROJECT 项目名称
 * # ___ENV 环境模式 development || production
 * # ___VERSION 版本号（不带v）
*/
//去掉提示 可取消
import 'whatwg-fetch'
Vue.config.productionTip = false;

import dayjs from "dayjs"
Vue.prototype.dayjs = dayjs;//可以全局使用dayjs

//过滤器
import Filters from 'build/filters'
Vue.use(Filters)

//服务端中间件
import * as $service from 'build/plugs/service'
Vue.use($service);
export { $service };

import{ traditionalizeString, simpleLizeString } from 'project/index/lang/traditionalize/str_util.js'
export { traditionalizeString, simpleLizeString };
//引用AES源码js
const CryptoJS = require('crypto-js');

//全局 Vue 实例 以及 第一层组件实例 app
var vm, dispatch = () => { }, commit = () => { };
const initVue = (_vm) => {
  vm = _vm;
  if (Vuex && vm.$store) {
    dispatch = vm.$store.dispatch;
    commit = vm.$store.commit;
  }
}; export { vm }; export { dispatch }; export { commit };

//配置入口
export const set = ({ vm }) => {
  if (vm) {
    initVue(vm);
  }
}

//用户相关
var user = {
  localKey: ___PROJECT + '_'
  // ,isLoged:false
  , data: {}
  , $login: () => { console.error("[未配置用户登录相关]"); }
  , $logout: () => { console.error("[未配置用户注销相关]"); }
  , $loginSuccess: (accountData) => {
    return new Promise(resolve => {
      accountData.platformKey = platformKey;
      user.data = accountData;
      window.localStorage.setItem(user.localKey + "user", JSON.stringify(accountData));
      // user.isLoged = true;

      window.$service.cache(1, { token: accountData.sessionId }).then(
        result => {
          if (!result.$.checkResult(result, true)) { return; }
          resolve(result.data)
          // window.location.href = "./#/index/page/welcome";
        }
      );
    })
  }
  , $logoutSuccess: () => {

  }
  , menus: []
  , $menusPrivilege: () => { console.error("[未配置用户菜单权限相关]"); }
};

//校验登录状态
let userString = window.localStorage.getItem(user.localKey + "user");
// console.log('userString', userString);
if (userString) {
  try {
    let userData = JSON.parse(userString);
    if (userData && userData.sessionId) {
      // user.isLoged = true;
      user.data = userData;
      // console.log('user.data', user.data)
    }
  } catch (e) {

  }
}

export { user };

//存放全局变量
let base = {}
//初始化环境变量
base.isRelease = false; // 正式环境
base.isBeta = false; // beta环境
base.isQC = false; // qc环境
base.isLocal = false; // 开发环境

let hostName = window.location.host.toLowerCase();
if(hostName.indexOf('127.0.0.1') == -1 && hostName.indexOf('localhost') == -1  && hostName.indexOf('qc') == -1){
	base.isRelease = true;
}else if(hostName.indexOf('candao-dmscd3-qc.can-dao') > -1 || hostName.indexOf('10.200.102.167:6105') > -1 || hostName.indexOf('saasv6-qc.can-dao.com:607') > -1 || hostName.indexOf('v6-qc') > -1){
	base.isQC = true;
}
export {base};

//全局相关
//# loading
var loadTimer, baseLoading = document.getElementsByClassName("baseLoading")[0];
export const show = () => {
  loadTimer && clearTimeout(loadTimer);
  baseLoading.style.display = "block"
}
export const hide = (timer = .2) => {
  loadTimer && clearTimeout(loadTimer);
  loadTimer = setTimeout(() => { baseLoading.style.display = "none"; }, timer * 1000);
}

// 全局接口loading
var dmsLoadingTimer, loadingDom = document.getElementsByClassName("dms-loading")[0];
export const loadingShow = () => {
  dmsLoadingTimer && clearTimeout(dmsLoadingTimer);
  let loadingImg = loadingDom && loadingDom.getElementsByTagName('img')[0];
  if (!loadingImg) {
    loadingImg = document.createElement('img');
    let imgUrl = require('project/static/images/DMS_loading.gif');
    loadingImg.setAttribute('src', imgUrl);
    loadingDom && loadingDom.appendChild(loadingImg);
  }
  loadingDom && (loadingDom.style.display = "block");
}
export const loadingHide = (timer = .2) => {
  dmsLoadingTimer && clearTimeout(dmsLoadingTimer);
  dmsLoadingTimer = setTimeout(() => { loadingDom && (loadingDom.style.display = "none"); }, timer * 1000);
}

// 时间long数据类型转换成日期格式‘yyyy-mm-dd hh:mm:ss’
export const getDateFmt = (time) => {
  if (time) {
    let date = new Date(time);
    let _year = date.getFullYear();
    let _mouth = (date.getMonth() + 1);
    let _date = date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate();
    let _hour = date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours();
    let _minute = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes();
    let _second = date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds();
    let _item = _year + '-' + (_mouth < 10 ? ('0' + _mouth) : _mouth) + '-' + _date + ' ' + _hour + ':' + _minute + ':' + _second;
    return _item;
  } else {
    return '';
  }
}
// 时间long数据类型转换成日期格式‘yyyy-mm-dd’或者7天前的今天
export const getDateSeven = (time) => {
  if (time) {
    let date = new Date();
    let date2 = new Date(date);
    date2.setDate(date.getDate() + time);
    let _year = date2.getFullYear();
    let _mouth = (date2.getMonth() + 1);
    let _date = date2.getDate() < 10 ? ('0' + date2.getDate()) : date2.getDate();
    let _item = _year + '-' + (_mouth < 10 ? ('0' + _mouth) : _mouth) + '-' + _date;
    return _item;
  } else {
    return '';
  }
}

/**
 * 多个格式化日期时间
 * @param date
 * @param joinStr
 * @returns {string}
 */
export const formatTime = (times, num = 0) => {
  if (times) {
		if(typeof(times)=='string'){ //兼容ie
			times = times.replace(/-/g, '/');  //ie不支持2019-01-01 01:01:01的写法，支持2019/01/01 01:01:01写法，所以在 new Date前先将-替换为/
		}
    let d = new Date(times);
    let year = d.getFullYear();
    let month = d.getMonth() + 1;
    let day = d.getDate() < 10 ? "0" + d.getDate() : "" + d.getDate();
    let hour = d.getHours();
    let minutes = d.getMinutes();
    let seconds = d.getSeconds();
    month = String(month).length == 1 ? `0${month}` : month;
    day = String(day).length == 1 ? `0${day}` : day;
    hour = String(hour).length == 1 ? `0${hour}` : hour;
    minutes = String(minutes).length == 1 ? `0${minutes}` : minutes;
    seconds = String(seconds).length == 1 ? `0${seconds}` : seconds;
    let buildTime_obj = {
      "0": `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`,
      "1": `${hour}:${minutes}:${seconds}`,
      "2": `${hour}`,
      "3": `${hour}:${minutes}`,
      "4": `${year}-${month}-${day}`,
      "5": `${year}-${month}-${day} ${hour}`,
      "6": `${month}-${day} ${hour}:${minutes}:${seconds}`,
      "7": `${minutes}`,
      "8": `${minutes}:${seconds}`,
      "9": `${year}-${month}-${day} ${hour}:${minutes}`,
      "10": `${month}-${day}`,
    }
    return buildTime_obj[num];
  } else {
    return ''
  }

}

/**
 * 格式化数字
 * @param n
 * @returns {*}
 */
const formatNumber = n => {
  n = n.toString();
  return n[1] ? n : '0' + n
};

/**
 * 格式化日期时间 hh:mm:ss
 * @param value
 * @returns {string}
 */
export const formatSeconds = (value) => {
  let result = parseInt(value)
  let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
  let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60))
  let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))
  result = `${h}:${m}:${s}`
  return result
}

/**
 * 格式化日期时间 hh:mm
 * @param value
 * @returns {string}
 */
export const formatDivision = (value) => {
  let result = parseInt(value)
  let h = Math.floor(result / 60) < 10 ? '0' + Math.floor(result / 60) : Math.floor(result / 60)
  let m = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))
  result = `${h}:${m}`
  return result
}

/**
 * 时分转为时间戳
 * @param time
 * @returns {string}
 */
export const countDown = (time) => {
  let hour = time.split(':')[0];
  let min = time.split(':')[1];
  let s = Number(hour * 60) + Number(min);
  return s;
}

/**
 * 是否为Null
 * @param object
 * @returns {Boolean}
 */
export const isNull = (object) => {
  if (object == null || typeof object == "undefined") {
    return true;
  }
  return false;
};

/**
 * 根据日期字符串获取星期几
 * @param dateString 日期字符串（如：yyyy-MM-dd），为空时为用户电脑当前日期
 * @returns {String}
 */
export const getWeek = (dateString) => {
  let date;
  if (isNull(dateString)) {
    date = new Date();
  } else {
    let dateArray = dateString.split("-");
    //处理当前时间
    date = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2]);
  }
  //getDay得到星期几然后charAt截取位置返回
  return "周" + "日一二三四五六".charAt(date.getDay());
};

/**
 * 根据日期得到第几周
 * @param dateString 日期字符串（如：yyyy-MM-dd）
 * @returns {string}
 */
export const getYearWeek = (dateString) => {
  let dateArray = dateString.split("-");
  let dateOne = new Date(Number(dateArray[0]), parseInt(dateArray[1]) - 1, Number(dateArray[2]))
  let dateTwo = new Date(Number(dateArray[0]), 0, 1)
  let d = Math.round((dateOne.valueOf() - dateTwo.valueOf()) / 86400000);
  return Number(dateArray[0]) + '-' + Math.ceil((d + ((dateTwo.getDay() + 1) - 1)) / 7)
};

/**
 * @returns { String } 传入时间或者当前时间的当周周一的年月日 yyyy-mm-dd
 */
export const getMonDay = (time) => {
  let nowTemp = time?new Date(time):new Date();//没有传入时间则为当前时间
  let oneDayLong = 24 * 60 * 60 * 1000;//一天的毫秒数
  let c_time = nowTemp.getTime();//当前时间的毫秒时间
  let c_day = nowTemp.getDay() || 7;//当前时间的星期几
  let m_time = c_time - (c_day - 1) * oneDayLong;//当前周一的毫秒时间
  let monday = new Date(m_time);//设置周一时间对象
  let m_year = monday.getFullYear();
  let m_month = monday.getMonth() + 1;
  let m_date = monday.getDate();
  return m_year + '-' + (m_month < 10 ? '0' + m_month : m_month) + '-' + (m_date < 10 ? '0' + m_date : m_date);//周一的年月日
}


//判断时间是否重叠
export class CheckTime {
  constructor() {
  }
  checkTime(a, b, x, y) {
    let times1 = [],
      times2 = [];
    if (a < b) {
      times1.push([a, b]);
    } else {
      times1.push([a, "24:00"], ["00:00", b]);
    }
    if (x < y) {
      times2.push([x, y]);
    } else {
      times2.push([x, "24:00"], ["00:00", y]);
    }
    let flag = false;
    //循环比较时间段是否冲突
    for (let i = 0; i < times1.length; i++) {
      if (flag)
        break;
      for (let j = 0; j < times2.length; j++) {
        if (this.check(times1[i][0], times1[i][1], times2[j][0], times2[j][1])) {
          flag = true;
          break;
        }
      }
    }
    return flag
  }
  check(a, b, x, y) {
    if (y < a || b < x) {
      return false;
    } else {
      return true;
    }
  }
}

//判断多个时段是否重叠
/**
 *
 * @param {*} arr [["08:00", "12:00"],["15:00", "20:00"],["19:00", "22:00"]]
 * @returns
 */
export const judegeDateTime=(arr) =>{
	let flag = false;
	for (var i = 0; i < arr.length; i++) {
		if (flag) return true;
		for (var j = 1 + i; j < arr.length; j++) {
			if (
				isDateIntersection(arr[i][0], arr[i][1], arr[j][0], arr[j][1])
			) {
				flag = true;
				return true;
			}
		}
	}
	return false;
}
function isDateIntersection(start1, end1, start2, end2) {
	if (end2 < start1 || end1 < start2) {
		return false;
	} else {
		return true;
	}
}


//时间间隔计算的函数(间隔天数)
//getDayDiff('2021-01-01', '2021-01-05'); // 输出4
export const  getDayDiff=(date1, date2)=> {
  const startTime = new Date(date1);
  const endTime = new Date(date2);

  const timeDiff = Math.abs(endTime.getTime() - startTime.getTime());
  const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

  return dayDiff;
}
/**
 * 数组对象去重
 * @param {Array[obj]} _arr 需要去重的数组对象1
 * @param {Array[obj]} _array 需要去重的数组对象2
 * @param {String} key 去重的标示
 * @returns {Array[obj]} 去重后的剩余部分
 */
export const dupArrObj = (_arr, _array, key) => {
  let arr1, arr2;
  _arr.length < _array.length ? (arr1 = _array, arr2 = _arr) : (arr1 = _arr, arr2 = _array);
  let arr = arr1.filter(item => {
    let somes = arr2.map(v => v[key]);
    return !somes.includes(item[key]);
  })
  return arr;
}


export const debounce = (func, wait = 300) => {   //默认300毫秒
  let timeout
  return function (...args) {
    let context = this
    if (timeout) clearTimeout(timeout)
    timeout = setTimeout(function () {
      func.apply(context, args)
    }, wait)
  }
}
//数组合并并去重
export const mergeArray=(arr1,arr2)=>{
  let _arr = new Array();
  for(let i=0;i<arr1.length;i++){
     _arr.push(arr1[i]);
  }
  for(let i=0;i<arr2.length;i++){
      let flag = true;
      for(let j=0;j<arr1.length;j++){
          if(arr2[i]==arr1[j]){
              flag=false;
              break;
          }
      }
      if(flag){
          _arr.push(arr2[i]);
      }
  }
  return _arr;
}


//AES加密 DMS约定使用CBC+PKCS5Padding+base64+utf-8 做加密解密

//解密方法
/**
 *
 * @param {*} word 需要解密的内容
 * @param {*} nowTime 时间戳
 * @returns
 */
 export const Decrypt = (word,nowTime) => {
  let dms_key = Utils.md5(`dms_${nowTime}`).substring(0, 16); //和后端约定dms_拼接时间戳，再md5后取前16位
  let key = CryptoJS.enc.Utf8.parse(dms_key);  //十六位十六进制数作为密钥
  let iv = CryptoJS.enc.Utf8.parse(dms_key);   //十六位十六进制数作为密钥偏移量

  let base64 = CryptoJS.enc.Base64.parse(word);
  let src = CryptoJS.enc.Base64.stringify(base64);
  let decrypt = CryptoJS.AES.decrypt(src, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
  let decryptStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptStr.toString();
}

//加密方法
/**
 *
 * @param {*} word 需要加密的内容
 * @param {*} nowTime 时间戳
 * @returns
 */
export const Encrypt = (word,nowTime=Date.now()) => {
  let dms_key = Utils.md5(`dms_${nowTime}`).substring(0, 16); //和后端约定dms_拼接时间戳，再md5后取前16位
  let key = CryptoJS.enc.Utf8.parse(dms_key);  //十六位十六进制数作为密钥
  let iv = CryptoJS.enc.Utf8.parse(dms_key);   //十六位十六进制数作为密钥偏移量
  console.log(dms_key)
  let src = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(src, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
  return {secretPassword:CryptoJS.enc.Base64.stringify(encrypted.ciphertext),timestamp:nowTime}
}

//获取路由参数
/**
 *
 * @param {*} name 参数名称
 * @returns
 */
export const getRouteParam=(name)=>{
	var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
	var r = window.location.hash.slice(window.location.hash.indexOf('?')+1).match(reg);//查询路由？后面的参数，并匹配正则
	if(r!=null)return  unescape(r[2]); return null;
}

//现数字千分位显示
/**
 *
 * @param {*} num 数字
 * @param {*} precision 保留小数
 * @param {*} separator 分隔符
 * @returns
 */
export const formatNumberSymbol=(num, precision, separator) =>{
	var parts;
	// 判断是否为数字
	if (!isNaN(parseFloat(num)) && isFinite(num)) {
			// 把类似 .5, 5. 之类的数据转化成0.5, 5, 为数据精度处理做准, 至于为什么
			// 不在判断中直接写 if (!isNaN(num = parseFloat(num)) && isFinite(num))
			// 是因为parseFloat有一个奇怪的精度问题, 比如 parseFloat(12312312.1234567119)
			// 的值变成了 12312312.123456713
			num = Number(num);
			// 处理小数点位数
			num = (typeof precision !== 'undefined' ? num.toFixed(precision) : num).toString();
			// 分离数字的小数部分和整数部分
			parts = num.split('.');
			// 整数部分加[separator]分隔, 借用一个著名的正则表达式
			parts[0] = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (separator || ','));

			return parts.join('.');
	}
	//return NaN;
 return num;
}

//查找菜单列表中的某个菜单
export const findMenu = (componentName)=>{
	const menu = user.data.menuList.find((i)=>{
		return i.componentName==componentName
	})
	return menu
}

// 刷新时更新缓存菜单
export const refreshMenu=(list)=>{
	//校验登录状态
	let userString = window.localStorage.getItem(user.localKey + "user");
	if (userString) {
		try {
			let userData = JSON.parse(userString);
			userData.menuList=list;//更新菜单
			if (userData && userData.sessionId) {
				user.data = userData;
				//更新菜单缓存
				window.localStorage.setItem(user.localKey + "user", JSON.stringify(userData));
			}
		} catch (e) {

		}
	}
}

//下载
export const downloadFile = (url)=>{
	if(url){
		const link = document.createElement("a");
		link.style.display = "none";
		link.href = url;
		link.setAttribute("download", "");
		link.setAttribute("target", "_blank");
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
}

// 校验字符串类型
export const safeStringMethod = (value)=>{
  if (typeof value === 'string') {
      return value;
  } else {
      // console.error('Expected a string, but got', typeof value);
      return ''; // 返回一个默认值，例如空字符串
  }
}



// WEBPACK FOOTER //
// core-dms/projects/candao-dms-std/common.js